var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"dense":"","outlined":"","persistent-placeholder":"","id":_vm.name,"label":_vm.label,"name":_vm.name},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }